












































import { computed, defineComponent, ref } from "@vue/composition-api";
import { SwiperOptions } from "swiper";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import { RecommendedUser } from "@scrile/api-provider/dist/api/RecommendedUserProvider";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";
import useAuthUser from "@/hooks/useAuthUser";
import useFollowing from "@/hooks/useFollowing";
import providers from "@/lib/api";
import BaseIcon from "@/components/BaseIcon";
import BaseIconButton from "@/components/BaseIconButton";
import BaseSpinner from "@/components/BaseSpinner";
import SuggestedCreatorsItem from "./components/SuggestedCreatorsItem";

export default defineComponent({
  name: "SuggestedCreators",
  components: {
    BaseIconButton,
    BaseSpinner,
    BaseIcon,
    Swiper,
    SwiperSlide,
    SuggestedCreatorsItem,
  },
  props: {
    userIds: { type: Array as () => string[], default: () => ["0"] },
  },
  setup(props) {
    const loading = ref(false);
    const hidden = ref(false);
    const { isMember } = useAuthUser();
    const suggestedCreators = ref<RecommendedUser[]>([]);
    const suggestedCreatorsIds = computed(() => suggestedCreators.value.map(i => i.userId));
    const showSuggestedCreatorsBlock = computed(() => isMember.value && suggestedCreators.value.length > 0);

    const { followingIdsList, toggle } = useFollowing(suggestedCreatorsIds, {
      globalCapture: true,
      watchMode: true,
    });
    const getFollowing = (userId: string): boolean => followingIdsList.value.includes(userId);

    const onToggleFollow = (user: UserPublicData) => {
      toggle(user.id);
    };

    const getCreators = async () => {
      if (!isMember.value) return;
      try {
        loading.value = true;
        const response = await providers.RecommendedUserProvider.search({
          data: {
            size: 1000,
            sort: "RANDOM;TIME",
            profileUserIds: props.userIds,
            includeFollowings: false,
          },
        });
        suggestedCreators.value = response.result;

        if (!suggestedCreators.value.length) return;
      } finally {
        loading.value = false;
      }
    };

    const swiperOptions: SwiperOptions = {
      spaceBetween: 12,
      slidesPerView: 1,
      slidesPerGroup: 1,
      slidesPerColumn: 3,
      slidesPerColumnFill: "row",
      allowTouchMove: true,
      freeMode: false,
      grabCursor: false,
      pagination: {
        el: ".suggested-creators__pagination",
        bulletElement: "div",
        bulletClass: "suggested-creators__pagination-bullet",
        bulletActiveClass: "__active",
        dynamicBullets: false,
        clickable: true,
      },
      navigation: {
        prevEl: ".suggested-creators__slider-prev",
        nextEl: ".suggested-creators__slider-next",
      },
    };

    getCreators();

    return {
      loading,
      hidden,
      isMember,
      showSuggestedCreatorsBlock,
      swiperOptions,
      suggestedCreators,
      followingIdsList,
      getFollowing,
      onToggleFollow,
    };
  },
});
